import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=6f89a0ed&scoped=true"
import script from "./Tag.ts?vue&type=script&lang=ts&external"
export * from "./Tag.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f89a0ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f89a0ed')) {
      api.createRecord('6f89a0ed', component.options)
    } else {
      api.reload('6f89a0ed', component.options)
    }
    module.hot.accept("./Tag.vue?vue&type=template&id=6f89a0ed&scoped=true", function () {
      api.rerender('6f89a0ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Forms/components/Tag/Tag.vue"
export default component.exports